import getOriginWithPrefix from './getOriginWithPrefix';
import Routes from '../routes.mjs';
import messages from './messages.json';
import formatDateWithLocale from './formatDateWithLocale';

const dateFormatLocale = 'en-US';

const getEventJsonLdData = (intl, event, url, coverImageUrl) => {
  const {
    title,
    slug,
    locationName,
    streetAddress,
    addressLocality,
    postalCode,
    addressRegion,
    addressCountry,
    startDate,
    endDate,
    description,
  } = event;

  return JSON.stringify({
    '@context': 'http://schema.org',
    '@type': 'Event',
    name: title,
    url: `${getOriginWithPrefix(url)}${Routes.findAndGetUrls(
      'event',
      { eventsPath: intl.formatMessage(messages.eventsPath), slug },
    ).urls.as}`,
    description,
    image: coverImageUrl && {
      '@type': 'ImageObject',
      url: coverImageUrl,
      height: 1186,
      width: 1920,
    },
    ...(startDate && {
      startDate: formatDateWithLocale(
        startDate,
        dateFormatLocale,
        { timeZone: 'Europe/Berlin' },
      ),
    }),
    ...(endDate && {
      endDate: formatDateWithLocale(
        endDate,
        dateFormatLocale,
        { timeZone: 'Europe/Berlin' },
      ),
    }),
    location: {
      '@type': 'Place',
      name: locationName || addressLocality,
      address: {
        '@type': 'PostalAddress',
        streetAddress,
        addressLocality,
        postalCode,
        addressRegion,
        addressCountry,
      },
    },
  });
};

export default getEventJsonLdData;
